export default {
  map_unavailable: 'Die Karte konnte nicht geladen werden. Bitte laden Sie die Seite neu.',
  stubs: {
    name: 'Delivery zone {{number}}',
  },
  buttons: {
    add_new_zone: 'Add new zone',
  },
  toasts: {
    failed_to_load_data: 'Failed to load delivery zones',
  },
};
